const getters = {
  cachedViews: (state) => state.cachedView.cachedViews,
  userInfo: (state) => state.user.userInfo,
  kefuUrl: (state) => state.user.kefuUrl,
  config: (state) => state.common.config,
}

export default getters
